<template>
  <div>
    <div ref="typeform" style="height: 400px"></div>
  </div>
</template>
<script>

  import * as typeformEmbed from '@typeform/embed'

  export default {

    async mounted() {
      let me = this

      await me.$nextTick()

      typeformEmbed.makeWidget(me.$refs.typeform, 'https://taiste.typeform.com/to/tVZOoc', {
        hideHeaders: true,
        hideFooter: true,
        opacity: 100,
        buttonText: 'Anna palautetta',
        onSubmit: function () {
          setTimeout(() => {
            me.$emit('done')
          }, 3000)
        },
      })
    },

  }

</script>